import { render } from "./Communicator.vue?vue&type=template&id=2f02868a"
import script from "./Communicator.vue?vue&type=script&lang=js"
export * from "./Communicator.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__